import { Season } from '@features/seasons/models/season.model';

export class LoadSeasons {
  static readonly type = '[Season] Load Seasons';
}

export class SetSeasons {
  static readonly type = '[Season] Set Seasons';
  constructor(public seasons: Season[]) {}
}

export class SelectSeason {
  static readonly type = '[Season] Select Season';
  constructor(public seasonId: string | null) {}
}

export class AddOrUpdateSeason {
  static readonly type = '[Season] Add or Update Season';
  constructor(public season: Season) {}
}

export class RemoveSeason {
  static readonly type = '[Season] Remove Season';
  constructor(public seasonId: string) {}
}
